import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

import { Observable } from 'rxjs';
import { NavService } from './nav.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard implements CanActivate {
  constructor(private router: Router,
    private auth: AuthService,
    private navService: NavService){}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  
  return this.isLoggedIn().then((isAuthenticated)=>{
    if(isAuthenticated) return true;
    else{
      console.log("stateurl",state.url)
      this.navService.setStoredUrl(state.url);
      this.router.navigate(['landscreen'], {skipLocationChange:true});
    }
  })
  }
  async isLoggedIn(): Promise<boolean>{
  return new Promise<boolean>((res, rej)=>{
    this.auth.isAuthenticated$.subscribe((isAuthenticaed)=>{
      if(!isAuthenticaed){
        if(localStorage.getItem('user') && localStorage.getItem('loginType')) res(true)
        else res(false);
      }
      else res(true);
    })
  })  
  }
}
